import { useNavigate } from 'react-router-dom'
import Page from '@/Components/Page'
import InputView from '../InputView'

const MapViewInput: InputView = () => {
  const navigate = useNavigate()

  return (
    <Page metaTitle='Explore venues on a Map - HeadBox' className='map-view-page'>
      <h1>Explore venues on a Map 🗺️</h1>
      <p>Map venue exploration coming soon.</p>
      <button className='hb-button secondary-button' onClick={() => navigate(-1)} type='button'>
        Back
      </button>
    </Page>
  )
}

export default MapViewInput
